import type { TProgressBreakpoint } from '@/modules/promotions/helpers/common';
import type { IResponsiveImageSrc } from '../../../helpers';

export enum LevelState {
  Active = 'active',
  Locked = 'locked',
  Canceled = 'canceled',
  Done = 'done',
  Issued = 'issued',
}

export interface ILevelItem {
  id: string;
  state: LevelState;
  percent: number;
  wagered: number;
  target: number;
  progress: string;
  progressLabelKey?: string;
  reward: string;
  rewardLabelKey?: string;
  rewardLabel: string;
  rewardSuffixKey?: string;
  image: string;
  glowColor: string;
  glowEndOpacity: number;
}

export type LevelReward =
  | { kind: 'freespins'; count: number }
  | { kind: 'bonus'; amount: number; labelKey?: string };

export type PromoRewardType = 'bets' | 'deps';

// Target value at each breakpoint - real bets wagered ($) for 'bets', deposit count for 'deps'.
type ProgressAmounts = Partial<Record<TProgressBreakpoint, number>> &
  Record<0 | 100, number>;

interface ILevelConfigBase {
  name: string;
  image: string;
  lockedImage: string;
  reward: LevelReward;
  // The bonus/freespin groupKey credited for completing this level - used to
  // tell "issued" apart from "done" once the player has activated it.
  rewardGroupKey: string;
  bg: IResponsiveImageSrc;
  glowColor: string;
  glowEndOpacity?: number;
  characterImage: IResponsiveImageSrc;
  // This level's artwork sits higher in its frame than the button circle
  // expects - nudge it down so it overflows the circle instead of floating off-center.
  artOverflows?: boolean;
}

export type ILevelConfig =
  | (ILevelConfigBase & {
      promoRewardType: 'bets';
      wagerAmounts: ProgressAmounts;
    })
  | (ILevelConfigBase & {
      promoRewardType: 'deps';
      depsCount: ProgressAmounts;
    });
